module.exports = __webpack_public_path__ + "14c73713-e4df-4dba-933b-057feeac8dd1.woff2";